{
  "hero": {
    "title": "ITS JumpStart",
    "description": "A lightweight site for CGI PH that showcases projects, pulls Markdown from Azure DevOps via Jekyll, and wraps everything in a React shell with header, sidebar, and footer — complete with dark mode.",
    "actions": [
      {
        "label": "Read Documentations",
        "href": "#",
        "variant": "outline"
      },
      {
        "label": "Browse Projects",
        "href": "#",
        "variant": "solid"
      }
    ],
    "heroImage": "/assets/img/hero-image.png",
    "heroImageAlt": "ITS hero art"
  },
  "what": {
    "title": "What ITS does",
    "subtitle": "Four work streams that power JumpStart engagements end-to-end.",
    "cards": [
      {
        "title": "Ingest & Model",
        "description": "Secure landing zones, pipelines, semantic models, and data contracts.",
        "icon": "Database",
        "tone": "crimson"
      },
      {
        "title": "Orchestrate & Govern",
        "description": "CI/CD for analytics assets, access controls, lineage, and quality gates.",
        "icon": "GitBranch",
        "tone": "crimson"
      },
      {
        "title": "Dashboards & KPIs",
        "description": "Decision-ready visuals aligned to a KPI catalog, delivered fast.",
        "icon": "LayoutDashboard",
        "tone": "crimson"
      },
      {
        "title": "AI Pilots",
        "description": "Forecasting, anomaly detection, and copilots grounded on governed data.",
        "icon": "BrainCircuit",
        "tone": "crimson"
      }
    ]
  },
  "quickLinks": {
    "title": "Quick links",
    "subtitle": "Jump straight to the tools teams use every day.",
    "items": [
      {
        "title": "Estimators",
        "description": "Complexity, pricing, and pattern-based estimates.",
        "href": "#",
        "tone": "amber",
        "icon": "Calculator"
      },
      {
        "title": "Resource Availability",
        "description": "Who's Open/Partial/Booked across roles.",
        "href": "#",
        "tone": "blue",
        "icon": "Users"
      },
      {
        "title": "Project Pipeline",
        "description": "Intake → Build → Validate → Enable, at a glance.",
        "href": "/operations-hub/project-pipeline/",
        "tone": "gold",
        "icon": "Network"
      },
      {
        "title": "Engagement State Machines",
        "description": "Canonical states, guards, and automation hooks.",
        "href": "/operations-hub/engagement-state-machine/",
        "tone": "slate",
        "icon": "GitGraph"
      },
      {
        "title": "Guides & Resources",
        "description": "Playbooks, patterns, and reference implementations.",
        "href": "/resources-and-reusables",
        "tone": "purple",
        "icon": "/assets/icons/guides-w.png",
        "iconHover": "/assets/icons/guides-w.png"
      },
      {
        "title": "ITS Roadmap",
        "description": "Quarterly focus and asset rollouts.",
        "href": "/operations-hub/its-roadmap/",
        "tone": "crimson",
        "icon": "Map"
      }
    ]
  }
}